export enum OAuth2GithubPrompt {
    SelectAccount = 'select_account',
}
